<template>
  <div class="home-page">
    <!-- 头部 -->
    <HeaderModel></HeaderModel>

    <!-- 主视觉区域 -->
    <section class="hero-section" ref="section0">
      <div class="hero-content">
        <h1 class="hero-title">ta- VNS安睡仪</h1>
        <h2 class="hero-subtitle">迷走神经疗愈效果评估</h2>
        <p class="hero-desc">每一次使用，数据都在见证改变</p>
        <p class="hero-text">
          通过先进的人脸生物数据采集技术，实时监测您的心率、HRV等生理指标，
          直观展示疗愈设备使用前后的健康数据变化
        </p>
        <button class="start-btn" @click="startCollection">
          开始采集
          <img
            class="arrow"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home1.png"
            alt=""
          />
        </button>
        <img
          @click="goto(1)"
          class="goto"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-17home4.png"
          alt=""
        />
      </div>
    </section>

    <!-- 使用流程 - 固定 4 列 -->
    <section class="process-section" id="target1" ref="section1">
      <div class="process-section-box">
        <div class="section-header">
          <h3 class="section-title">使用流程</h3>
          <p class="section-subtitle">EQUIPMENT USAGE PROCESS</p>
        </div>
        <div class="process-steps">
          <div class="step-card" v-for="(step, index) in steps" :key="index">
            <div class="step-number">{{ index + 1 }}</div>
            <h4 class="step-title">{{ step.title }}</h4>
            <p class="step-desc">{{ step.desc }}</p>
          </div>
        </div>
        <div class="process-steps2">
          <div class="step-card">
            <div v-for="(step, index) in steps" :key="index">
              <div class="step-number">{{ index + 1 }}</div>
            </div>
          </div>
          <div class="step-card">
            <div v-for="(step, index) in steps" :key="index">
              <h4 class="step-title">{{ step.title }}</h4>
              <p class="step-desc">{{ step.desc }}</p>
            </div>
          </div>
        </div>
        <img
          @click="goto(2)"
          class="goto"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-17home4.png"
          alt=""
        />
      </div>
    </section>

    <!-- 核心功能 - 固定 4 列 -->
    <section class="features-section" id="target2" ref="section2">
      <div class="section-header">
        <h3 class="section-title">核心功能</h3>
        <p class="section-subtitle">CORE FUNCTIONS OF THE DEVICE</p>
      </div>
      <div class="features-grid">
        <div
          class="feature-card"
          v-for="(feature, index) in features"
          :key="index"
        >
          <img class="feature-icon" :src="feature.icon" alt="" />
          <h4 class="feature-title">{{ feature.title }}</h4>
          <p class="feature-subtitle">{{ feature.subtitle }}</p>
          <p class="feature-desc">{{ feature.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <FooterModel ref="section3"></FooterModel>
  </div>
</template>

<script>
import { me } from "@/api/index";
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";

export default {
  name: "Home",
  components: {
    FooterModel,
    HeaderModel,
  },
  data() {
    return {
      currentSection: 0, // 当前区块索引: 0=主视觉, 1=流程, 2=功能, 3=页脚
      sections: [], // 存储区块元素引用
      isScrolling: false, // 滚动动画锁
      wheelDelta: 0, // 滚轮累积值
      steps: [
        { title: "授权摄像头", desc: "允许系统访问您的摄像头" },
        { title: "疗愈前采集", desc: "记录疗愈前的基础状态" },
        {
          title: "使用ta-VNS安睡仪",
          desc: "按照指导使用迷走神经疗愈设备",
        },
        { title: "采集对比数据并生成报告", desc: "查看安睡仪带来的生理变化" },
      ],
      features: [
        {
          icon: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home3.png",
          color: "#e3f2fd",
          title: "30秒快速采集",
          subtitle: "通过摄像头采集面部视频",
          desc: "只需30秒，即可获取完整的生理数据。支持手机、和电脑。",
        },
        {
          icon: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home6.png",
          color: "#e8f5e9",
          title: "4项核心指标",
          subtitle: "全面的生理数据分析",
          desc: "心率、HRV、呼吸率、压力水平。",
        },
        {
          icon: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home4.png",
          color: "#fff3e0",
          title: "疗愈效果对比",
          subtitle: "直观展示前后变化",
          desc: "自动计算疗愈前后各项指标的变化。",
        },
        {
          icon: "https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home5.png",
          color: "#fce4ec",
          title: "健康报告生成",
          subtitle: "专业分析",
          desc: "基于科学算法，生成包含健康评分和压力评估的详细报告。",
        },
      ],
    };
  },
  created() {
    // this.$toast.success('这是一条普通提示');
  },
  computed: {
    isMobile() {
      let screenWidth =
        document.documentElement.clientWidth || document.body.offsetWidth;
      if (screenWidth > 767) {
        return false;
      } else {
        return true;
      }
    },
  },
  beforeDestroy() {
    // 仅桌面端需要清理事件
    if (!this.isMobile) {
      this.destroyDesktopScroll();
    }
  },
  mounted() {
    localStorage.removeItem("mode");
    localStorage.removeItem("times");
    this.init();

    // ✅ 仅桌面端启用全屏滚动切换
    if (!this.isMobile) {
      this.initDesktopScroll();
    }
  },
  methods: {
    /**
     * 初始化桌面端滚动逻辑
     */
    initDesktopScroll() {
      // 初始化区块引用
      this.sections = [
        this.$refs.section0,
        this.$refs.section1,
        this.$refs.section2,
        this.$refs.section3?.$el,
      ].filter((el) => el);

      // 监听滚轮事件（仅桌面端）
      window.addEventListener("wheel", this.handleWheel, { passive: false });

      // 监听键盘方向键（仅桌面端）
      window.addEventListener("keydown", this.handleKeydown);
    },

    /**
     * 清理桌面端滚动逻辑
     */
    destroyDesktopScroll() {
      window.removeEventListener("wheel", this.handleWheel);
      window.removeEventListener("keydown", this.handleKeydown);
    },

    /**
     * 处理鼠标滚轮事件（仅桌面端）
     */
    handleWheel(e) {
      // 滚动动画中直接返回
      if (this.isScrolling) {
        console.log("滚动中");
        e.preventDefault();
        return;
      }

      console.log("去滚动");
      // ✅ 优化 1: 移除 Safari 时间戳防抖，改用更轻量的累积判断
      this.wheelDelta += e.deltaY;

      // ✅ 优化 2: 降低触发阈值（50 → 30），更灵敏
      if (Math.abs(this.wheelDelta) > 30) {
        const direction = this.wheelDelta > 0 ? "down" : "up";
        this.switchSection(direction);
        this.wheelDelta = 0; // 立即重置
      }

      e.preventDefault();
    },

    /**
     * 处理键盘方向键（仅桌面端）
     */
    handleKeydown(e) {
      if (this.isScrolling) return;

      if (e.key === "ArrowDown") {
        e.preventDefault();
        this.switchSection("down");
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        this.switchSection("up");
      }
    },

    /**
     * 切换区块（仅桌面端）
     */
    switchSection(direction) {
      // 设置滚动锁
      this.isScrolling = true;

      let targetIndex = this.currentSection;
      if (
        direction === "down" &&
        this.currentSection < this.sections.length - 1
      ) {
        targetIndex++;
      } else if (direction === "up" && this.currentSection > 0) {
        targetIndex--;
      }

      // 索引未变化则直接解锁返回
      if (targetIndex === this.currentSection) {
        this.isScrolling = false;
        return;
      }
      if (targetIndex == 2 && direction === "up") {
        targetIndex = 1
      }
      this.currentSection = targetIndex;
      const target = this.sections[targetIndex];

      if (target) {
        // ✅ 优化 3: 使用自定义平滑滚动，替代 scrollIntoView
        this.smoothScrollTo(target.offsetTop);
      }
    },
    smoothScrollTo(targetPosition) {
      console.log("处理滚动事件");
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = 1000; // 动画时长（毫秒）
      let startTime = null;

      // 缓动函数（easeInOutCubic）
      const easeInOutCubic = (t) => {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      };

      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const ease = easeInOutCubic(progress);

        window.scrollTo(0, startPosition + distance * ease);

        if (timeElapsed < duration) {
          requestAnimationFrame(animate);
        } else {
          // 动画完成，解锁滚动
          setTimeout( () => {
            console.log("滚动完成，解锁");
          this.isScrolling = false;
          }, 300 )
        }
      };

      requestAnimationFrame(animate);
    },
    async init() {
      try {
        await me({}).then((res) => {});
      } catch (err) {}
    },
    goto(type) {
      if (type == 1) {
        // 1. 获取目标元素（比如元素id为"target"）
        let targetElement = document.getElementById("target1");

        // 2. 点击事件触发滚动
        targetElement.scrollIntoView({
          behavior: "smooth", // 平滑滚动（去掉则瞬间跳转）
          block: "start", // 元素对齐方式：start(顶部)、center(居中)、end(底部)
          inline: "nearest", // 水平对齐（默认即可）
        });
      } else {
        // 1. 获取目标元素（比如元素id为"target"）
        let targetElement = document.getElementById("target2");

        // 2. 点击事件触发滚动
        targetElement.scrollIntoView({
          behavior: "smooth", // 平滑滚动（去掉则瞬间跳转）
          block: "start", // 元素对齐方式：start(顶部)、center(居中)、end(底部)
          inline: "nearest", // 水平对齐（默认即可）
        });
      }
    },
    startCollection() {
      if (!JSON.parse(localStorage.getItem("inChina"))) {
        this.$IpPop.open();
        return;
      }
      if (this.$token.isLogin()) {
        this.$router.replace("/IntendCollect");
      } else {
        this.$router.replace("/Login");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  /* ===== 基础设置 ===== */
  .home-page {
    width: 100%;
    min-height: 100vh;
    background: #fff;

    // ✅ 启用滚动吸附，辅助定位
    scroll-snap-type: y mandatory;
    scroll-behavior: smooth;
  }

  .goto {
    display: none;
  }
  /* ===== 主视觉区域 ===== */
  .hero-section {
    position: relative;
    background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9mianIMG.png");
    // background-size: 120rem 62rem;
    background-size: 100% 100vh;
    background-repeat: no-repeat;
    text-align: center;
    overflow: hidden;
    // height: 49.6rem;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .hero-content {
      position: relative;
      z-index: 1;
      max-width: 56rem;
      margin: 0 auto;
      padding: 0 2rem;
      .hero-title {
        font-size: 2.4rem;
        background: linear-gradient(
          to right,
          #0074fc 0%,
          #0074fc 36%,
          #e59cff 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        margin-bottom: 0.8rem;
        font-weight: 700;
        line-height: 1.2;

        font-weight: 800;
        font-size: 4.496rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .hero-subtitle {
        font-weight: bold;
        font-size: 4.4rem;
        color: #101424;
        line-height: 6.2rem;
        letter-spacing: 0.052rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .hero-desc {
        font-weight: 600;
        font-size: 1.6rem;
        color: rgba(16, 20, 36, 0.88);
        line-height: 1.6rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 2rem 0rem;
      }

      .hero-text {
        font-weight: 400;
        font-size: 1.4rem;
        color: rgba(16, 20, 36, 0.56);
        line-height: 2.1rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        width: 43.2rem;
        margin: auto;
        margin-bottom: 2.4rem;
      }
      .start-btn {
        background: #0074fc;
        box-shadow: 0px 0px 0.6rem 0px rgba(0, 116, 252, 0.5);
        color: #fff;
        border: none;
        padding: 1rem 2.4rem;
        border-radius: 0.6rem;
        font-size: 1rem;
        cursor: pointer;
        transition: all 0.3s;
        display: inline-flex;
        align-items: center;
        gap: 0.6rem;
        .arrow {
          width: 1.2rem;
          height: 1.2rem;
        }
      }

      .start-btn:hover {
        transform: translateY(-0.15rem);
        box-shadow: 0 0.5rem 1.2rem rgba(33, 150, 243, 0.4);
      }
    }
  }

  /* ===== 使用流程 - 固定 4 列 ===== */
  .process-section {
    height: 100vh;
    background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home10.png");
    // background-size: 120rem 67.5rem;
    background-size: 100% 100vh;
    background-repeat: no-repeat;
    margin-top: -0.8rem;

    display: flex;
    align-items: center;
    justify-content: center;
    .process-section-box {
      width: 72rem;
      height: 30.35rem;
      background: #ffffff;
      box-shadow: 0px 0px 1.9rem 0px rgba(4, 59, 123, 0.04);
      border-radius: 1.2rem;
      .section-header {
        text-align: center;
        margin-bottom: 1.6rem;
        .section-title {
          font-weight: bold;
          font-size: 3.3rem;
          color: #1f2937;
          line-height: 5.3rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          padding-top: 4.8rem;
        }

        .section-subtitle {
          font-weight: 400;
          font-size: 0.9rem;
          color: #797b84;
          line-height: 1.45rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
      .process-steps2 {
        display: none;
      }
      .process-steps {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 2rem;
        max-width: 70rem;
        margin: 0 auto;
        padding: 0 2.4rem;
        .step-card {
          padding: 1.6rem 1.4rem;
          text-align: center;
          .step-number {
            display: inline-flex;
            background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home7.png");
            background-size: 3.9rem 3.9rem;
            background-repeat: no-repeat;
            width: 3.9rem;
            height: 3.9rem;
            color: #fff;
            font-weight: bold;
            font-size: 1.6rem;
            font-style: normal;
            text-transform: none;
            align-items: center;
            justify-content: center;
            margin-bottom: 1.6rem;
          }

          .step-title {
            font-weight: bold;
            font-size: 0.9rem;
            color: #101424;
            line-height: 1.1rem;
            text-align: center;
            font-style: normal;
            text-transform: none;
            margin-bottom: 0.64rem;
          }

          .step-desc {
            width: 6rem;
            margin: auto;
            font-weight: 400;
            font-size: 0.8rem;
            color: #797b84;
            line-height: 1.3rem;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
  }

  /* ===== 核心功能 - 固定 4 列 ===== */
  .features-section {
    height: 100vh;
    background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home8.png");
    // background-size: 120rem 60rem;
    background-size: 100% 100vh;
    background-repeat: no-repeat;
    margin-top: -0.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .section-header {
      text-align: center;
      margin-bottom: 3rem;
      .section-title {
        font-weight: bold;
        font-size: 3.3rem;
        color: #1f2937;
        line-height: 5.3rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        // padding-top: 16rem;
      }

      .section-subtitle {
        font-weight: 400;
        font-size: 0.9rem;
        color: #797b84;
        line-height: 1.45rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .features-grid {
      width: 72rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .feature-card {
        background: #ffffff;
        box-shadow: 0px 0px 1.4rem 0px rgba(4, 59, 123, 0.16);
        border-radius: 1.2rem;
        text-align: center;
        transition: all 0.3s;
        width: 15rem;
        height: 20rem;
        padding: 2.1rem 0rem;
        box-sizing: border-box;

        .feature-icon {
          width: 2.6rem;
          height: 2.6rem;
          margin: auto;
          margin-bottom: 2.096rem;
        }

        .feature-title {
          font-weight: bold;
          font-size: 1.1rem;
          color: #101424;
          line-height: 1.2rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .feature-subtitle {
          font-weight: 500;
          font-size: 1.1rem;
          color: rgba(16, 20, 36, 0.9);
          line-height: 1.75rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin-top: 0.8rem;
          margin-bottom: 1.52rem;
        }

        .feature-desc {
          width: 12.9rem;
          font-weight: 400;
          font-size: 1rem;
          color: #797b84;
          line-height: 1.6rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          margin: auto;
        }
      }

      .feature-card:hover {
        box-shadow: 0 0.8rem 1.6rem rgba(0, 0, 0, 0.1);
        transform: translateY(-0.4rem);
      }
    }
  }

  /* ===== 动画 ===== */
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-1rem);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  @keyframes slideUp {
    from {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
    to {
      opacity: 0;
      transform: translateX(-50%) translateY(-1rem);
    }
  }
}

/* ===== 仅手机端改变布局 ===== */
@media (max-width: 767px) {
  /* ===== 基础设置 ===== */
  .home-page {
    width: 100%;
    min-height: 100vh;
    background: #fff;
  }

  /* ===== 主视觉区域 ===== */
  .hero-section {
    position: relative;
    background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-17home1.png");
    // background-size: 120rem 62rem;
    background-size: 100% 82.375rem;
    background-repeat: no-repeat;
    text-align: center;
    height: 82.375rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding-top: 6rem;
    .hero-content {
      position: relative;
      z-index: 1;
      max-width: 46rem;
      margin: 0 auto;
      padding: 0 2rem;
      .hero-title {
        font-size: 4rem;
        background: linear-gradient(
          to right,
          #0074fc 0%,
          #0074fc 36%,
          #e59cff 100%
        );
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        margin-bottom: 1rem;
        font-weight: 700;
        line-height: 1.2;

        font-weight: 800;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .hero-subtitle {
        font-weight: bold;
        font-size: 4rem;
        color: #101424;
        line-height: 6.2rem;
        letter-spacing: 0.052rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .hero-desc {
        font-weight: 600;
        font-size: 2.25rem;
        color: rgba(16, 20, 36, 0.88);
        line-height: 2.25rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin: 2.3rem 0rem;
      }

      .hero-text {
        font-weight: 400;
        font-size: 1.7rem;
        color: rgba(16, 20, 36, 0.56);
        line-height: 2.9rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        width: 42rem;
        margin: auto;
        margin-bottom: 10.375rem;
      }
      .start-btn {
        background: #0074fc;
        box-shadow: 0px 0px 0.6rem 0px rgba(0, 116, 252, 0.5);
        color: #fff;
        width: 41.375rem;
        height: 6.5rem;
        border-radius: 1.75rem;
        font-size: 2rem;
        cursor: pointer;
        // transition: all 0.3s;
        display: inline-flex;
        align-items: center;
        gap: 0.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .arrow {
          display: none;
          // width: 1.2rem;
          // height: 1.2rem;
        }
      }
      .goto {
        width: 4.75rem;
        height: 4.75rem;
        display: block;
        margin: auto;
        margin-top: 8.375rem;
      }
    }
  }

  /* ===== 使用流程 - 固定 4 列 ===== */
  .process-section {
    height: 97rem;
    background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-17home3.png");
    // background-size: 120rem 67.5rem;
    background-size: 100% 101.5rem;
    background-repeat: no-repeat;
    margin-top: -0.8rem;

    display: flex;
    align-items: center;
    justify-content: center;
    .process-section-box {
      border-radius: 1.2rem;
      .section-header {
        text-align: center;
        margin-bottom: 1.6rem;
        .section-title {
          font-weight: bold;
          font-size: 4rem;
          color: #1f2937;
          line-height: 5.5rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
          // padding-top: 4.8rem;
        }

        .section-subtitle {
          font-weight: 400;
          font-size: 1.25rem;
          color: #797b84;
          line-height: 1.45rem;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
      .process-steps {
        display: none;
      }

      .goto {
        width: 4.75rem;
        height: 4.75rem;
        display: block;
        margin: auto;
        margin-top: 5rem;
      }
      .process-steps2 {
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 70rem;
        margin: 0 auto;
        padding: 0 2.4rem;
        .step-card {
          padding: 1.6rem 1.4rem;
          height: 55rem;
          text-align: center;
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex-direction: column;
          .step-number {
            display: inline-flex;
            background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home7.png");
            background-size: 5.75rem 5.75rem;
            background-repeat: no-repeat;
            width: 5.75rem;
            height: 5.75rem;
            font-weight: bold;
            font-size: 2.25rem;
            color: #ffffff;
            text-align: center;
            font-style: normal;
            text-transform: none;
            align-items: center;
            justify-content: center;
          }

          .step-title {
            font-weight: 800;
            font-size: 2.25rem;
            color: #101424;
            line-height: 2.75rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 0.75rem;
          }

          .step-desc {
            font-weight: 400;
            font-size: 2rem;
            color: #797b84;
            line-height: 2.25rem;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }
      }
      /* 核心：伪元素生成垂直线 */
      .process-steps2::after {
        content: ""; /* 伪元素必须有content */
        position: absolute;
        top: 4rem;
        left: 15%; /* 水平居中 */
        transform: translateX(-50%); /* 修正1px宽度的偏移，保证完全居中 */
        width: 0.25rem; /* 线的粗细 */
        height: 85%; /* 线的高度 */
        background-color: #c2defe; /* 线的颜色 */
        /* 可选：加圆角 */
        border-radius: 1px;
        /* 可选：加阴影 */
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
        z-index: -1;
      }
    }
  }

  /* ===== 核心功能 - 固定 4 列 ===== */
  .features-section {
    height: 159rem;
    background-image: url("https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-17home2.png");

    background-size: 100% 159rem;
    background-repeat: no-repeat;
    // margin-top: -0.8rem;
    .section-header {
      text-align: center;
      margin-bottom: 1.6rem;
      .section-title {
        font-weight: bold;
        font-size: 4rem;
        color: #1f2937;
        line-height: 5.5rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        padding-top: 15rem;
      }

      .section-subtitle {
        font-weight: 500;
        font-size: 1.25rem;
        color: #797b84;
        line-height: 1.45rem;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin-bottom: 7.2rem;
      }
    }
    .features-grid {
      // width: 72rem;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .feature-card {
        background: #ffffff;
        border: 0.125rem solid rgba(0, 116, 252, 0.5);
        border-radius: 1.5rem;
        text-align: left;
        // transition: all 0.3s;
        width: 42.375rem;
        height: 29rem;
        padding: 3rem 2.5rem;
        margin-bottom: 2rem;
        box-sizing: border-box;

        .feature-icon {
          width: 5.25rem;
          height: 5.25rem;
          margin-bottom: 3rem;
          display: block;
        }

        .feature-title {
          font-weight: bold;
          font-size: 2rem;
          color: #101424;
          line-height: 3rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 1.5rem;
        }

        .feature-subtitle {
          font-weight: 500;
          font-size: 2rem;
          color: rgba(16, 20, 36, 0.8);
          line-height: 3.1875rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 1.5rem;
        }

        .feature-desc {
          font-weight: 400;
          font-size: 1.75rem;
          color: #797b84;
          line-height: 2.8125rem;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .feature-card:hover {
        box-shadow: 0 0.8rem 1.6rem rgba(0, 0, 0, 0.1);
        transform: translateY(-0.4rem);
      }
    }
  }

  /* ===== 动画 ===== */
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-1rem);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }

  @keyframes slideUp {
    from {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
    to {
      opacity: 0;
      transform: translateX(-50%) translateY(-1rem);
    }
  }
}
</style>